module.exports = __webpack_public_path__ + "media/Components/Logos/icon-tool-tobottom-b4cc2953880edc2f4b60f80fe4159e42.svg";